function stablePartOutput(value) {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function findMatchingPart(existingParts, incomingPart, index) {
  if (!Array.isArray(existingParts) || existingParts.length === 0) {
    return null;
  }
  if (incomingPart.id) {
    const byId = existingParts.find((p) => p.id === incomingPart.id);
    if (byId) return byId;
  }
  if (incomingPart.toolCallId) {
    const byCall = existingParts.find((p) => p.toolCallId === incomingPart.toolCallId);
    if (byCall) return byCall;
  }
  if (index < existingParts.length && existingParts[index]?.type === incomingPart.type) {
    return existingParts[index];
  }
  // No toolName-only fallback: a turn can contain several calls to the same tool, and matching
  // by name alone would copy one call's persisted output onto another. Parts without a stable
  // id/toolCallId and a matching positional slot are treated as new.
  return null;
}

/**
 * Live ui_chunk owns in-flight text/reasoning. Persisted store updates
 * (message_added) own tool outputs once written.
 */
function mergeStreamPart(storePart, streamPart) {
  if (streamPart.type === "text" || streamPart.type === "reasoning") {
    return streamPart;
  }
  if (streamPart.type !== "tool") {
    return streamPart;
  }

  const storeOutput = storePart.output;
  const streamOutput = streamPart.output;
  if (storeOutput === undefined || storeOutput === null) {
    return streamPart;
  }
  if (stablePartOutput(storeOutput) === stablePartOutput(streamOutput)) {
    return streamPart;
  }

  return {
    ...streamPart,
    output: storePart.output,
    state: storePart.state ?? streamPart.state,
    errorText: storePart.errorText ?? streamPart.errorText,
  };
}

/**
 * Merge a streamed assistant turn with the copy already in the store so
 * message_added updates are not clobbered by throttled ui_chunk flushes.
 */
export function mergeStreamTurnWithStore(existingMessage, incomingTurn) {
  if (!existingMessage?.parts?.length || !incomingTurn?.parts?.length) {
    return incomingTurn;
  }

  const mergedParts = incomingTurn.parts.map((part, index) => {
    const existingPart = findMatchingPart(existingMessage.parts, part, index);
    if (!existingPart) return part;
    return mergeStreamPart(existingPart, part);
  });

  return { ...incomingTurn, parts: mergedParts };
}
